import AOS from 'aos';


$(() => {
  const reducedMQ = window.matchMedia("(prefers-reduced-motion: reduce)");
  // only initialise if user has not set 'prefers-reduced-motion' to 'reduce'
  if (!reducedMQ.matches) {
    AOS.init({
      duration: 800,
      delay: 100,
      once: true,
    });
  }
  else {
    AOS.init({ disable: true });
  }
});